@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/post-cards-4x6/the-woods-post-card-stack-content/the-woods-post-card-stack-content.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
.the-woods-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
}
.the-woods-container .color-strip-area {
  height: 100%;
  transform: rotate(180deg);
  padding: 1rem 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
}
.the-woods-container .color-strip-area .the-woods-strain-type {
  font-family: "alternate-gothic-no-3-d", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1.5rem;
  letter-spacing: 0.135rem;
  line-height: 108.333%;
  color: white;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  text-transform: uppercase;
}
.the-woods-container .the-woods-content-area {
  height: 100%;
  flex: 1;
  padding: 0.875rem 1rem 1.25rem 1rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
.the-woods-container .the-woods-content-area .top-half-of-card-with-images {
  height: 8.125rem;
  width: 100%;
  gap: 0.625rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}
.the-woods-container .the-woods-content-area .top-half-of-card-with-images .brand-logo {
  max-height: 8.125rem;
  max-width: 16.625rem;
  align-self: center;
}
.the-woods-container .the-woods-content-area .top-half-of-card-with-images .no-brand-logo {
  color: transparent;
}
.the-woods-container .the-woods-content-area .top-half-of-card-with-images .company-logo-and-craft {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  justify-content: flex-start;
  align-items: center;
}
.the-woods-container .the-woods-content-area .top-half-of-card-with-images .company-logo-and-craft .company-logo {
  max-height: 4.75rem;
  max-width: 4.75rem;
}
.the-woods-container .the-woods-content-area .top-half-of-card-with-images .company-logo-and-craft .no-company-logo-or-craft-badge {
  color: transparent;
}
.the-woods-container .the-woods-content-area .top-half-of-card-with-images .company-logo-and-craft .craft-badge {
  max-height: 3.125rem;
  max-width: 3.125rem;
}
.the-woods-container .the-woods-content-area .product-name-and-lineage {
  margin-top: 0.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  justify-content: flex-end;
  align-items: flex-start;
  height: 3.375rem;
  width: 100%;
  font-size: 1.625rem;
  line-height: 96.154%;
  letter-spacing: 0.52px;
}
.the-woods-container .the-woods-content-area .product-name-and-lineage .product-name {
  min-height: 1.5625rem;
  font-family: fields, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1.625rem;
  line-height: 96.154%;
  letter-spacing: 0.0325rem;
}
.the-woods-container .the-woods-content-area .product-name-and-lineage .lineage-name {
  min-height: 0.75rem;
  font-family: "alternate-gothic-no-3-d", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1.125rem;
  line-height: 111.111%;
  letter-spacing: 0.0225rem;
  text-transform: uppercase;
}
.the-woods-container .the-woods-content-area .content-divider {
  height: 0.25rem;
  width: 100%;
  margin: 0.75rem 0;
}
.the-woods-container .the-woods-content-area .product-details {
  height: 14.125rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: flex-start;
  align-items: flex-start;
}
.the-woods-container .the-woods-content-area .product-details .product-badges {
  min-width: 4.375rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: flex-start;
  align-items: flex-start;
}
.the-woods-container .the-woods-content-area .product-details .product-badges .the-woods-badge {
  width: 4.375rem;
}
.the-woods-container .the-woods-content-area .product-details .product-information {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: flex-start;
  align-items: flex-start;
}
.the-woods-container .the-woods-content-area .price-section {
  margin-top: 0.5rem;
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  justify-content: flex-start;
  align-items: center;
}
.the-woods-container .the-woods-content-area .price-section app-column-primary-price {
  display: block;
}
.the-woods-container .the-woods-content-area .price-section app-column-primary-price ::ng-deep .product-variant-price {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: fields, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 2rem;
  overflow: visible;
  letter-spacing: 0.04rem;
}
.the-woods-container .the-woods-content-area .price-section app-column-primary-price ::ng-deep .product-variant-price .product-variant-current-price {
  display: flex;
  flex-direction: row;
}
.the-woods-container .the-woods-content-area .price-section app-column-primary-price ::ng-deep .product-variant-price .product-variant-previous-price {
  font-family: fields, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1rem;
  letter-spacing: 0.02rem;
  color: #aaaaaa;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.the-woods-container .the-woods-content-area .price-section app-column-primary-price ::ng-deep .product-variant-price .leading-text-current-price {
  order: 3;
}
.the-woods-container .the-woods-content-area .price-section .the-woods-label-inflator {
  font-family: rubik, sans-serif;
  font-weight: 600;
  font-size: 0.5625rem;
  line-height: 122.222%;
}
.the-woods-container .the-woods-content-area .price-section .the-woods-label-inflator ::ng-deep .product-label {
  border-radius: 0.125rem;
}
/*# sourceMappingURL=the-woods-post-card-stack-content.component.css.map */
